<template>
  <div class="ccpay-invite">
    <div class="ccpay-invite-header">
      <span @click="back">退後</span>
      <span>邀請資訊</span>
      <span></span>
    </div>
    <div class="ccpay-invite-settings" v-if="hasRebateRole">
      <h3>邀請返佣設定</h3>
      <div class="settings-item">
        <label for="buy-rebate">購入返佣金額：</label>
        <input type="number" v-model="buyRebate" id="buy-rebate" />
      </div>
      <div class="settings-item">
        <label for="sell-rebate">售出返佣金額：</label>
        <input type="number" v-model="sellRebate" id="sell-rebate" />
      </div>
      <button @click="saveSettings">保存</button>
    </div>
    <br />
    <div class="ccpay-invite-list">
      <h3>邀請成員列表</h3>
      <table>
        <thead>
          <tr>
            <th>用戶名</th>
            <th style="text-align:right">註冊時間</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member, index) in inviteMembers" :key="index">
            <td>{{ member.traders_name }}</td>
            <td class="text-right">{{ member.created_time }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        buyRebate: 0,
        sellRebate: 0,
        hasRebateRole: 0,
        inviteMembers: []
      };
    },
    created() {
      this.$axios.get("/v1/account/config/invite_dealer").then((res) => {
        if (res.code == 0) {
          this.hasRebateRole = res.data.child_rebate_role ? 1 : 0
          this.buyRebate = parseFloat(res.data.child_hide_legal_fee_buy);
          this.sellRebate = parseFloat(res.data.child_hide_legal_fee_sell);
          this.inviteMembers = res.data.inviteUser;
        }
      });
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      saveSettings() {
        const settings = {
          child_hide_legal_fee_buy: this.buyRebate,
          child_hide_legal_fee_sell: this.sellRebate
        };
        this.$axios.post("/v1/account/config/invite_dealer/set", settings).then((res) => {
          if (res.code === 0) {
            this.$Toast("保存成功");
          } else {
            this.$Toast("保存失敗");
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ccpay-invite {
    padding: 1rem;
    background: white;
    font-family: Arial, sans-serif;

    .ccpay-invite-header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 1rem;
      border-bottom: 1px solid #eee;
      font-weight: bold;
    }

    .ccpay-invite-settings {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;

      h3 {
        margin-bottom: 0.75rem;
        font-size: 1.2rem;
        color: #333;
        border-bottom: 2px solid #ddd;
        padding-bottom: 0.5rem;
      }

      .settings-item {
        margin-bottom: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        label {
          margin-right: 0.5rem;
          font-size: 1rem;
          color: #555;
        }

        input {
          flex: 1;
          padding: 0.5rem;
          font-size: 1rem;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 60%;
        }
      }

      button {
        float: right;
        padding: 0.5rem 1rem;
        background-color: #26a2ff;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1rem;

        &:hover {
          background-color: #1f8ed6;
        }
      }
    }

    .ccpay-invite-list {
      h3 {
        margin-bottom: 0.75rem;
        font-size: 1.2rem;
        color: #333;
        border-bottom: 2px solid #ddd;
        padding-bottom: 0.5rem;
      }

      table {
        width: 100%;
        border-collapse: collapse;

        th,
        td {
          padding: 0.75rem;
          text-align: left;
          border-bottom: 1px solid #eee;
          font-size: 1rem;
          color: #555;
        }

        th {
          font-weight: bold;
          background-color: #f9f9f9;
        }

        td.text-right {
          text-align: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/inviteInfo.vue